export default {
    remove: 'ลบ'
}
